import ModalDetail from "./ModalDetail"

export default ModalDetail 